import { render, staticRenderFns } from "./complaintsAftercare.vue?vue&type=template&id=63df6cc2&scoped=true"
import script from "./complaintsAftercare.vue?vue&type=script&lang=js"
export * from "./complaintsAftercare.vue?vue&type=script&lang=js"
import style0 from "./complaintsAftercare.vue?vue&type=style&index=0&id=63df6cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63df6cc2",
  null
  
)

export default component.exports